import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Actions extends Component {
    constructor(props) {
        super();

        this.onChange = this.onChange.bind(this);
        this.changeView = this.changeView.bind(this);

        this.state = {
            value: props?.defaultValue ?? '',
            showEditMode: props.showOpened ?? false,
        };
    }

    onChange(e) {
        this.setState({ value: e.target.value });
    }

    changeView(bool) {
        this.setState({ showEditMode: bool });
    }

    render() {
        const { t } = this.props;

        return this.state.showEditMode ? (
            <div className={this.props.additionalClassname ?? ''}>
                <form
                    className="gsc-config-from-page"
                    onSubmit={(e) => this.props.onChange(e, this.state.value)}
                >
                    <div>
                        <input
                            name="form-input"
                            className="gsc-config-from-page-input"
                            type={this.props.inputType ?? 'text'}
                            value={this.state.value}
                            onChange={this.onChange}
                            style={this.props.inputStyles ? { ...this.props.inputStyles } : {}}
                        />
                    </div>
                    <div className="d-flex align-items-end gap-10">
                        <button
                            type="submit"
                            className="button button-filled button-primary"
                            disabled={this.props.loading}
                        >
                            {t('search.list_keywords.save_config')}
                        </button>
                        <button
                            type="button"
                            className="gsc-config-from-page-sc"
                            onClick={() => this.changeView(false)}
                        >
                            {t('search.list_keywords.discard')}
                        </button>
                    </div>
                </form>
            </div>
        ) : (
            <div className={`change-gsc-field-form ${this.props.additionalClassname ?? ''}`}>
                <button
                    type="button"
                    className="add-cluster-btn gap-8"
                    id="name-edit-btn"
                    onClick={() => this.changeView(true)}
                >
                    <i className="icon-settings1" />
                    {this.props.header}
                    <span>
                        {this.props.customNumber ??
                            (typeof this?.state?.value === 'string'
                                ? this?.state?.value?.split(',')?.length
                                : this?.state?.value?.length) ??
                            0}
                    </span>
                </button>
            </div>
        );
    }
}

export default withTranslation()(Actions);
